
import { Vue, Component } from 'vue-property-decorator';
import PickupInfo from '@/features/schedule-pickup/components/PickupInfo.vue';
import DoneToDashboardFooter from '@/features/common/components/DoneToDashboardFooter.vue';
import AttentionList, { ListType } from '@/features/common/components/AttentionList.vue';

@Component({
  components: {
    PickupInfo,
    DoneToDashboardFooter,
    AttentionList,
  },
})
export default class DropoffRequested extends Vue {
  private attentionList: ListType = {
    title: this.$t('scheduledPickups.dropoffRequested.rememberDropoffSubtitle') as string,
    list: [
      {
        text: this.$t('scheduledPickups.dropoffRequested.cutoffTimeLookup') as string,
        icon: 'mdi-clock-alert-outline',
      },
      {
        text: this.$t('scheduledPickups.dropoffRequested.beforeCutoffTime') as string,
        icon: 'mdi-truck-outline',
      },
      {
        text: this.$t('scheduledPickups.dropoffRequested.printShippingLabel') as string,
        icon: 'mdi-printer-outline',
      },
    ],
  }
}
